
    import I18n from 'i18nObj';
    
      import 'translations/assignments.assignment_sync_settings';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('assignments.assignment_sync_settings');
  